var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCareright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36364 0.902497L7.34736 5.45999C7.5023 5.59616 7.59112 5.79245 7.59112 5.99872C7.59113 6.20502 7.50231 6.40133 7.34736 6.5375L2.36364 11.095C2.12866 11.3175 1.78615 11.3862 1.48365 11.2712C1.18114 11.1563 0.969896 10.8788 0.941162 10.5562L0.941162 1.44498C0.968666 1.12123 1.17864 0.842497 1.48242 0.727489C1.78617 0.611239 2.12739 0.679981 2.36364 0.902497Z",
    fill: "#1C2154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCareright);
export default __webpack_public_path__ + "static/media/icon-careright.b4cfe48b.svg";
export { ForwardRef as ReactComponent };